import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStackCards = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	strokeWidth: 2,
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10.8334 15.8333L20 12.5L29.1667 15.8333L20 19.1667L10.8334 15.8333Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M29.1667 20.8333L20 24.1667L10.8334 20.8333" }),
		/* @__PURE__ */ _jsx("path", { d: "M29.1667 25.8333L20 29.1667L10.8334 25.8333" })
	]
});
const ForwardRef = forwardRef(SvgStackCards);
export default ForwardRef;
